var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyNotification = function SvgEmptyNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#606B76",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyNotification_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.497,
    cy: 60,
    r: 43.2,
    fill: "#606B76",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#5B6770",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.88,
    clipPath: "url(#EmptyNotification_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.467 77.92h-7.936M72.9 55.12v-.08c0-6.847-5.552-12.4-12.4-12.4-6.847 0-12.4 5.553-12.4 12.4v6.21a2.12 2.12 0 0 1-1.17 1.895l-1.247.623a4.598 4.598 0 0 0 2.056 8.712h25.524a4.598 4.598 0 0 0 2.056-8.71l-1.248-.622a2.13 2.13 0 0 1-1.17-1.898z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EmptyNotification_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5 36h48v48h-48z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyNotification_svg__a",
    width: 98.494,
    height: 98.496,
    x: 11.249,
    y: 10.752,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.024
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.283333 0 0 0 0 0.31875 0 0 0 0 0.354167 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_516_39312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_516_39312",
    result: "shape"
  })))));
};
export default SvgEmptyNotification;